// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentImage_wrapper__KCfsj","background":"ContentImage_background__5PzYr","caption":"ContentImage_caption__P-RSg"};